export default function resizeImage(file, maxWidth, maxHeight, callback) {
  // Function logic inside a new Promise
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const img = new Image();

      img.onload = function () {
        let width = img.width;
        let height = img.height;

        // Check if either width or height is higher than the max values
        if (width > maxWidth || height > maxHeight) {
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Return base64 data URL instead of blob URL
        const dataUrl = canvas.toDataURL("image/png", 0.9);
        resolve(dataUrl);
      };

      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };

      img.src = event.target.result;
      img.crossOrigin = "Anonymous";
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsDataURL(file);
  });

  // Check if a callback is provided
  if (typeof callback === "function") {
    promise
      .then((result) => callback(null, result))
      .catch((error) => callback(error));
  } else {
    // Return the promise if no callback is provided
    return promise;
  }
}
